import React from 'react'
import EmployeeForm from './EmployeeForm'
import { EMPLOYEE_DETAIL } from '../../urls'
import { usePutRequest } from '../../hooks/request'

export default function EmployeeUpdate({ onCancel, onSuccess, item }) {
    const brandUpdate = usePutRequest({ url: EMPLOYEE_DETAIL.replace('{id}', item.id) })

    async function onSubmit(data) {
        const { success } = await brandUpdate.request({ data })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Изменить</b>
            </h1>
            <EmployeeForm loading={brandUpdate.loading} initialValues={item} onSubmit={onSubmit} onCancel={onCancel} />
        </div>
    )
}
